import { render, staticRenderFns } from "./PlantioSoja23Matopiba.vue?vue&type=template&id=18ae33a2&lang=pug"
import script from "./PlantioSoja23Matopiba.vue?vue&type=script&lang=js"
export * from "./PlantioSoja23Matopiba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports